export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-softgamings.vue?vue&type=template&id=14647e1d"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-softgamings.vue?vue&type=template&id=14647e1d
// module id = YaKT
// module chunks = 0